import * as types from './types';
import axios from 'axios';
import {API_URL_PATHS} from "../../constants/url";
import {getTokenHeader} from "../../helpers/tokenHelper";

export const activateSnapshot = () => ({type: types.ACTIVATE_SNAPSHOT});

export const deactivateSnapshot = () => ({type: types.DEACTIVATE_SNAPSHOT});

// TODO/refactor: save a snapshot to a specific spcimen analysis
export const saveSnapshot = (
  snapshot,
  specimenId,
  specimenIdArray,
  assigneeId,
) => async (dispatch) => {
  try {
    const body = {
      snapshot,
      specimenId,
      assigneeId,
    };

    const res = await axios.post(
      `${API_URL_PATHS.apiUrl}/snapshot`,
      body,
      getTokenHeader(),
    );
    dispatch({
      type: types.ASSIGN_SNAPSHOTS,
      payload: { snapshotId: res.data._id },
    });
    dispatch({ type: types.SAVE_SNAPSHOT, snapshot: res.data });
  } catch (error) {
    console.error(error);
  }
};

export const showSnapshot = (bool) => {
  return {type: types.SHOW_SNAPSHOT, payload: bool}
};

export const selectSnapshot = (snapshot) => ({type: types.SELECT_SNAPSHOT, payload: snapshot});

export const getSnapshots = (snapshotIds) => async dispatch => {
  try {
    const res = await axios.post(`${API_URL_PATHS.apiUrl}/getSnapshots`, {idArray: snapshotIds}, getTokenHeader());
    if (res.data.length){
      dispatch({type: types.GET_SNAPSHOTS_SUCCESS, payload: res.data});
    } else {
      dispatch({type: types.GET_SNAPSHOTS_SUCCESS, payload: []});
    }

  } catch (e) {
    console.log(e);
  }

};

export const deleteSnapshot = (snapshotId, specimenId) => {
  try {
    const body = {specimenId, snapshotId};
    axios.post(`${API_URL_PATHS.apiUrl}/deleteSnapshot`, body, getTokenHeader());
    return({type: types.DELETE_SNAPSHOT, payload: {id: snapshotId}});
  } catch (e) {
    console.log(e);
  }

};

export const clearSnapshots = () => ({type: types.CLEAR_SNAPSHOT_LIST});


export const saveTempSnapshot = (snapshot) => ({type: types.TEMP_SNAPSHOT, snapshot});
